module.exports = __webpack_public_path__ + "static/soc-one_2x-0032582ceaabd0940ab30042ff9a3767.png";